import { HandelsregisterBezeichnungEnum } from '../v2024';

export const HandelsregisterBezeichnungEnumLabels = {
    HRA: 'HRA' as HandelsregisterBezeichnungEnum,
    HRB: 'HRB' as HandelsregisterBezeichnungEnum,
    GsR: 'GsR' as HandelsregisterBezeichnungEnum,
    PR: 'PR' as HandelsregisterBezeichnungEnum,
    GnR: 'GnR' as HandelsregisterBezeichnungEnum,
    VR: 'VR' as HandelsregisterBezeichnungEnum
};

/**
 * Mappt den Enum-Wert (z.B. GsR, GnR) auf den UPPER_CASE
 * Übersetzungs-Key-Suffix (z.B. GSR, GNR).
 * Damit die Werte weiterhin als GsR/GnR übertragen werden,
 * aber die i18n-Keys ESLint-konform in UPPER_CASE sind.
 */
export const handelsregisterBezeichnungToTranslationKey =
    (value: HandelsregisterBezeichnungEnum): string =>
        value ? value.toUpperCase() : '';

